import type { ReactNode } from "react";

import { confirmable } from "react-confirm";

import { Button, Icon } from "simplydo/react/ui";
import { Modal } from "simplydo/react/ui";

type ConfirmModalProps = {
  show?: boolean;
  proceed?: () => void;
  dismiss?: () => void;
  cancel?: () => void;
  title: string;
  confirmation: ReactNode;
};

const ConfirmModal = ({
  show,
  proceed,
  dismiss,
  cancel,
  title,
  confirmation,
}: ConfirmModalProps) => {
  return (
    <Modal
      open={!!show}
      onClose={dismiss ?? (() => {})}
      basic
      size="small"
      className="no-scroll"
      closeOnDimmerClick={false}
    >
      <Modal.Header content={title} />
      <Modal.Content>
        <p>{confirmation}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic inverted onClick={cancel ?? (() => {})}>
          <Icon name="remove" /> Cancel
        </Button>
        <Button primary onClick={proceed ?? (() => {})}>
          <Icon name="checkmark" /> Confirm
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default confirmable(ConfirmModal);
